import OSprite from "./sprites/OSprite";
import Omy from "../Omy";

export default class OSlider extends OSprite {
    constructor(texture, atlas, debugSlide = false) {
        super(texture, atlas);

        this._vertical = true;
        this._property = "y";
        this._target = null;
        this._minSlideValue = 0;
        this._maxSlideValue = 0;
        this._sliderWay = 0;
        this._percent = 0;
        this._currentData = 0;
        this._startDragTarget = false;

        if (debugSlide)
            Omy.add.regDebugMode(this);
        this._debugSlide = debugSlide;
        this._isBlock = false;

        let rect = this.getLocalBounds();
        Omy.add.hintArea(this,
            { x: rect.x - 10, y: rect.y - 10, width: rect.width + 20, height: rect.height + 200 },
            0);

        this.drag = true;
        this.allowHorizontalDrag = !this._vertical;
        this.allowVerticalDrag = this._vertical;

        this.addDragUpdate(this._updateDragSlide, this);
        this.addDragStop(this._onStopDrag, this);

        this.buttonMode = true;
    }

    /**     * @public     */
    setSliderData(min, max) {
        this._minSlideValue = min;
        this._maxSlideValue = max;
        this._sliderWay = this._maxSlideValue - this._minSlideValue;
        if (this._vertical)
            this.boundsDragRect(0, min, Number.MAX_VALUE, max);
        else
            this.boundsDragRect(min, 0, max, Number.MAX_VALUE);
    }

    /**     * @public     */
    setTargetData(min, max) {
        this._minTargetValue = min;
        this._maxTargetValue = max;
        this._targetWay = this._maxTargetValue - this._minTargetValue;

        this.updateSlidePos();
    }

    /**     * @public     */
    forceUpdate(value) {
        this._percent = Math.abs((value - this._minTargetValue) / this._targetWay);
        this[this._property] = this._minSlideValue + this._sliderWay * this._percent;
    }

    /**     * @public     */
    resetSlider() {
        this._percent = 0;
        this[this._property] = this._minSlideValue + this._sliderWay * this._percent;
        if (this._target)
            this._target[this._property] = this._minTargetValue + this._targetWay * this._percent;
    }

    updateSlidePos() {
        if (this._target) {
            let dd;
            if (this._target[this._property] > this._minTargetValue) {
                dd = this._minTargetValue;
            } else if (this._target[this._property] < this._maxTargetValue) {
                dd = this._maxTargetValue;
            } else {
                dd = this._target[this._property];
            }

            this._percent = Math.abs((dd - this._minTargetValue) / this._targetWay);
            this[this._property] = this._minSlideValue + this._sliderWay * this._percent;
            if (this[this._property] < this._minSlideValue) {
                this[this._property] = this._minSlideValue;
            } else if (this[this._property] > this._maxSlideValue) {
                this[this._property] = this._maxSlideValue;
            }
            this._currentData = this._minTargetValue + this._targetWay * this._percent;
            if (this._debugSlide)
                Omy.warn("updateSlidePos", this[this._property], this._target && this._target[this._property]);
            this.emit("updating_target", this._currentData, this._percent);
        }
    }

    _updateDragSlide() {
        if (!this._startDragTarget) this._onStartDragTarget();

        this._percent = Math.abs((this[this._property] - this._minSlideValue) / this._sliderWay);
        this._currentData = this._minTargetValue + this._targetWay * this._percent;
        if (this._target)
            this._target[this._property] = this._currentData;
        if (this._debugSlide)
            Omy.warn("_updateDragSlide", this._target && this._target[this._property]);
        this.emit("updating", this._currentData, this._percent);
    }

    _onStopDrag() {
        this.emit("stop", this._currentData, this);

    }

    /**     * @private     */
    _onStopDragTarget() {
        let data = {};
        data[this._property] = this._target[this._property] +
            (((this._vertical) ? Omy.mouse.mouseY : Omy.mouse.mouseX) - this._saveMouse) / ((Date.now() - this._dropTime) / 100);

        if (data[this._property] > this._minTargetValue) {
            data[this._property] = this._minTargetValue;
        } else if (data[this._property] < this._maxTargetValue) {
            data[this._property] = this._maxTargetValue;
        }
        Omy.add.tween(this._target, data, 0.2, this._onStopTween.bind(this));
    }

    _onStopTween() {
        this._startDragTarget = false;

    }

    /**     * @private     */
    _onStartDragTarget() {
        this._saveMouse = (this._vertical) ? Omy.mouse.mouseY : Omy.mouse.mouseX;
        this._dropTime = Date.now();
        this._startDragTarget = true;
    }

    update() {
        if (this._startDragTarget) {
            this.updateSlidePos();
        }
        super.update();
    }

    addStopCallback(f, c) {
        this.on("stop", f, c);
    }

    addUpdateCallback(f, c) {
        this.on("updating", f, c);
    }

    addUpdateTargetCallback(f, c) {
        this.on("updating_target", f, c);
    }

    removeStopCallback(f, c) {
        this.off("stop", f, c);
    }

    removeUpdateCallback(f, c) {
        this.off("updating", f, c);
    }

    removeUpdateTargetCallback(f, c) {
        this.off("updating_target", f, c);
    }

    destroy(options) {
        this._target = null;
        this._property = null;
        return super.destroy(options);
    }

    set vertical(value) {
        this._vertical = value;
        this._property = (this._vertical) ? "y" : "x";
        this.allowHorizontalDrag = !this._vertical;
        this.allowVerticalDrag = this._vertical;
        if (this._vertical)
            this.boundsDragRect(0, this._minSlideValue, Number.MAX_VALUE, this._maxSlideValue);
        else
            this.boundsDragRect(this._minSlideValue, 0, this._maxSlideValue, Number.MAX_VALUE);
    }

    set target(value) {
        this._target = value;
        this._target.drag = true;
        this._target.allowHorizontalDrag = !this._vertical;
        this._target.allowVerticalDrag = this._vertical;

        this._target.addDragStop(this._onStopDragTarget, this);
        this._target.addDragStart(this._onStartDragTarget, this);
        // this._target.addDragUpdate(this._onUpdateDragTarget, this);
    }

    set isBlock(value) {
        this._isBlock = value;
    }

    get isBlock() {
        return this._isBlock;
    }

    get percent() {
        return this._percent;
    }

    get inDown() {
        return this._startDragTarget;
    }
}
